(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("InquiryMonad", [], factory);
	else if(typeof exports === 'object')
		exports["InquiryMonad"] = factory();
	else
		root["InquiryMonad"] = factory();
})(window, function() {
return 